import React from 'react';

import * as S from './ErrorBoundary.styles';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.log({ err: { message: error }, component: 'unknown' });
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.log({ err: { message: error }, component: 'unknown' });
    this.setState({ hasError: true });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <S.Overlay>
          <S.Container>
            <S.ImgWrapper>
              <S.StyledImg />
            </S.ImgWrapper>
            <S.TextWrapper>
              <S.Title>Что-то пошло не так</S.Title>
              <S.Description>Попробуйте ещё раз</S.Description>
            </S.TextWrapper>
            <S.StyledButton onClick={() => window.location.reload()}>
              Попробовать снова
            </S.StyledButton>
          </S.Container>
        </S.Overlay>
      );
    }
    return children;
  }
}
